import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { useNavigate } from "react-router-dom";

const ListCampaign = () => {
  const { translatedLabels, getCampaignList } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const navigate = useNavigate();

  const [campaigns, setCampaigns] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchCampaigns = async () => {
      const res = await getCampaignList(search);

      if (res?.status) {
        setCampaigns(res.list);
      }
    };

    fetchCampaigns();
  }, [getCampaignList, search]);

  return (
    <div className="content-part pt-5 px-0">
      <div
        style={{ position: "sticky", top: 0, zIndex: 1, background: "white" }}
        className="pb-3 px-2 pt-3 d-flex align-items-center justify-content-between gap-2"
      >
        <div className="w-100">
          <input
            placeholder={
              screenLabels?.search_campaign?.label_value ||
              "Search Campaigns..."
            }
            type="text"
            className="form-control w-100"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              navigate("/campaign-create");
            }}
          >
            Create
          </button>
        </div>
      </div>

      <div className="container-fluid mt-2 mb-2">
        <div className="row g-3">
          {/* {campaigns.map((campaign) => {
            const expired = isExpired(campaign.expiry_left);
            const progress = (campaign.totalSignUps / campaign.maxSignUp) * 100;

            return (
              <div key={campaign.id} className="col-12 col-md-6 col-lg-4">
                <div
                  className="card border-0 shadow-sm h-100 campaign-card cursor-pointer"
                  onClick={() =>
                    navigate(`/campaign-details`, {
                      state: { campaign },
                    })
                  }
                >
                  <div className="card-body d-flex flex-column pb-0">
                    <div className="d-flex justify-content-between align-items-start">
                      <h6 className="fw-bold mb-1">{campaign.name}</h6>

                      <span
                        className={`badge ${
                          expired ? "bg-danger" : "bg-success"
                        }`}
                      >
                        {expired ? "Expired" : "Active"}
                      </span>
                    </div>

                    <small className="text-muted mb-2">
                      {getRemainingTime(campaign.expiry_left)}
                    </small>

                    <div className="mt-2">
                      <div className="d-flex justify-content-between small">
                        <span>
                          {campaign.totalSignUps} of {campaign.maxSignUp} slots
                          filled
                        </span>
                        <span>{Math.round(progress)}%</span>
                      </div>

                      <div className="progress mt-1" style={{ height: "6px" }}>
                        <div
                          className={`progress-bar ${
                            progress >= 100 ? "bg-danger" : "bg-primary"
                          }`}
                          style={{ width: `${progress}%` }}
                        ></div>
                      </div>
                    </div>

                    <div className="mt-2 small text-muted">
                      Per User Limit:{" "}
                      <span className="fw-semibold text-dark mb-0">
                        {campaign.per_user_limit}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })} */}

          {campaigns.length > 0 ? (
            campaigns.map((campaign) => {
              return (
                <div key={campaign.code} className="col-12 col-md-6 col-lg-4">
                  <div
                    className="card border-0 shadow-sm h-100 campaign-card cursor-pointer"
                    onClick={() =>
                      navigate(`/campaign-details`, {
                        state: {
                          campaign: {
                            code: campaign.code,
                            name: campaign.name,
                          },
                        },
                      })
                    }
                  >
                    <div className="card-body d-flex flex-column pb-0">
                      <div className="d-flex justify-content-between align-items-start">
                        <h5 className="fw-bold mb-1">{campaign.name}</h5>

                        <span
                          className={`badge ${
                            campaign.status === "Expired"
                              ? "bg-danger"
                              : "bg-success"
                          }`}
                        >
                          {campaign.status}
                        </span>
                      </div>

                      <small className="text-muted mb-2">
                        {campaign.expiry_left}
                      </small>

                      <div className="mt-2">
                        <div className="d-flex justify-content-between small">
                          <span>{campaign.slots_filled}</span>
                          <span>{campaign.percentage}%</span>
                        </div>

                        <div
                          className="progress mt-1"
                          style={{ height: "6px" }}
                        >
                          <div
                            className={`progress-bar ${
                              campaign.percentage >= 100
                                ? "bg-danger"
                                : "bg-primary"
                            }`}
                            style={{ width: `${campaign.percentage}%` }}
                          ></div>
                        </div>
                      </div>

                      <div className="mt-2 small text-muted">
                        Per User Limit:{" "}
                        <span className="fw-semibold text-dark mb-0">
                          {campaign.per_user_limit}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center">No Campaigns Available.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListCampaign;
